import ProductStore from './ProductStore';

export default {
    productStore: new ProductStore()
};
